import { render } from "./LocalLoader.vue?vue&type=template&id=9f5fa868&scoped=true"
const script = {}

import "./LocalLoader.vue?vue&type=style&index=0&id=9f5fa868&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f5fa868"]])

export default __exports__